import { create } from 'zustand';

export interface ChatMessage {
  id: string;
  playerId: string;
  playerName: string;
  message: string;
  timestamp: number;
  type: 'chat' | 'system' | 'move';
}

interface ChatStore {
  messages: ChatMessage[];
  unreadCount: number;
  isChatOpen: boolean;
  
  // Actions
  addMessage: (message: ChatMessage) => void;
  clearMessages: () => void;
  markAsRead: () => void;
  toggleChat: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  unreadCount: 0,
  isChatOpen: false,
  
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, message],
    unreadCount: state.isChatOpen ? state.unreadCount : state.unreadCount + 1,
  })),
  
  clearMessages: () => set({ messages: [], unreadCount: 0 }),
  
  markAsRead: () => set({ unreadCount: 0 }),
  
  toggleChat: () => set((state) => ({ 
    isChatOpen: !state.isChatOpen,
    unreadCount: state.isChatOpen ? state.unreadCount : 0,
  })),
}));